import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=2ea7bfda&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewsView.vue"
export default component.exports